import React from 'react';
import PropTypes from 'prop-types';

import {
  Link,
  IconLogo,
  TranslationProvider,
} from '@resy/ui-kitchen';

import ERROR_CODE from './RatingErrorCodes';
import YellowQuestion from '../../../images/icons/question.svg';

const RatingFormErrors = ({ errorStatus }) => (
  <div className="RatingForm RatingForm__error">
    <div className="RatingForm__head RatingForm__row">
      <IconLogo />
      <YellowQuestion width={50} height={50} />
      { errorStatus === ERROR_CODE.timeLimit
            && (
              <>
                <TranslationProvider translationKey="rate_outside_window_title">
                  <h1>Oops! This reservation falls outside the two-week submission window.</h1>
                </TranslationProvider>
                <TranslationProvider translationKey="rate_error_body">
                  <p>
                    {'If you think this is in error, please email <a href="mailto:support@resy.com">support@resy.com</a>.'}
                  </p>
                </TranslationProvider>
              </>
            )}
      { errorStatus === ERROR_CODE.alreadyRated
            && (
              <>
                <TranslationProvider translationKey="rate_already_rated_title">
                  <h1>Oops! It looks like you already completed this survey.</h1>
                </TranslationProvider>
                <TranslationProvider translationKey="rate_error_body">
                  <p>
                    {'If you think this is in error, please email <a href="mailto:support@resy.com">support@resy.com</a>.'}
                  </p>
                </TranslationProvider>
              </>
            )}
      { errorStatus === ERROR_CODE.generic
            && (
              <>
                <TranslationProvider translationKey="rate_generic_error_title">
                  <h1>There was a problem. Please try again.</h1>
                </TranslationProvider>
              </>
            )}
    </div>
    <div className="RatingForm__ctas RatingForm__row">
      <TranslationProvider translationKey="rate_link_to_home">
        <Link
          lg
          variant="button-primary"
          href="/"
        >
          Go to the Home Page
        </Link>
      </TranslationProvider>
      <TranslationProvider translationKey="rate_link_to_reservations">
        <Link
          lg
          variant="button-secondary"
          href="/account/reservations-and-notify"
        >
          Go to Reservations
        </Link>
      </TranslationProvider>
    </div>
  </div>
);

RatingFormErrors.propTypes = {
  errorStatus: PropTypes.string,
};

RatingFormErrors.defaultProps = {
  errorStatus: false,
};

RatingFormErrors.displayName = 'RatingFormErrors';
export default RatingFormErrors;
